/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import DashboardUserLayout from "../../layouts/dashboardUserLayout";
import ProfileAddPortfolioModule from "../../modules/User/Profile/ProfileAddPortfolio";

const ProfileAddPortfolio = (props) => {
  return (
    <DashboardUserLayout>
      <div className="p-d-flex p-justify-center p-mt-5 profile-module">
        <div className="p-grid p-justify-center">
          <ProfileAddPortfolioModule />
        </div>
      </div>
    </DashboardUserLayout>
  );
};

export default ProfileAddPortfolio;
